export const TRANSLATION_GROUP_GENERAL_SETTINGS_PAYMENT_COUNTRY_GROUPS = Symbol('general-settings.payment-systems.country-groups');

export const ADMIN_GENERAL_SETTINGS_PAYMENT_COUNTRY_GROUPS_UPDATE_ROUTE_NAME = Symbol('admin.settings.payment-systems.country-groups.update');

export const SETTINGS_PAYMENT_COUNTRY_GROUPS_LIST_URL = 'admin/bank_transfer_country_groups/list';
export const SETTINGS_PAYMENT_COUNTRY_GROUPS_CREATE_URL = 'admin/bank_transfer_country_groups';
export const SETTINGS_PAYMENT_COUNTRY_GROUPS_UPDATE_URL = 'admin/bank_transfer_country_groups/:id';
export const SETTINGS_PAYMENT_COUNTRY_GROUPS_REMOVE_URL = 'admin/bank_transfer_country_groups/:id';

export const SETTINGS_PAYMENT_COUNTRY_GROUPS_ITEM_URL = 'admin/bank_transfer_country_groups/:id/data_by_country_group';

export const SETTINGS_PAYMENT_COUNTRY_GROUPS_LIST_QUERY_KEY = 'general-settings.payment-systems.country-groups.list';
export const SETTINGS_PAYMENT_COUNTRY_GROUPS_SAVE_MUTATION_KEY = 'general-settings.payment-systems.country-groups.save';
export const SETTINGS_PAYMENT_COUNTRY_GROUPS_REMOVE_MUTATION_KEY = 'general-settings.payment-systems.country-groups.remove';

export const SETTINGS_PAYMENT_COUNTRY_GROUPS_ITEM_QUERY_KEY = 'general-settings.payment-systems.country-groups.item';
